import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppContent from './AppContent';
import axios from 'axios';
import Loader from './components/Loader';
import Header from './components/Header';
import Footer from './components/Footer';
import Mantenimiento from './components/Mantenimiento';
import BASE_URL from './config/config';
import ScrollToTop from './components/ScrollToTop';

const Routering = () => {
  const [authenticated, setAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [tokenInfo, setTokenInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [enMantenimiento, setEnMantenimiento] = useState(false);
  const [verificandoMantenimiento, setVerificandoMantenimiento] = useState(true);

  useEffect(() => {
    const verificarMantenimiento = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/ajustes/en_mantenimiento`);
        if (response.data.success && response.data.ajuste.valor === 'si') {
          setEnMantenimiento(true);
        }
      } catch (error) {
        console.error('Error al verificar mantenimiento:', error);
      } finally {
        setVerificandoMantenimiento(false);
      }
    };

    verificarMantenimiento();
  }, []);

  useEffect(() => {
    const verificarToken = async () => {
      try {
        const token = localStorage.getItem('AuthToken');
        if (!token) {
          throw new Error('No se encontró token');
        }

        const response = await axios.get(`${BASE_URL}/autenticacion`, {
          headers: {
            Authorization: `${token}`,
          },
        });

        setAuthenticated(true);
        setUserRole(response.data.role);
        setTokenInfo(response.data);
      } catch (error) {
        setAuthenticated(false);
        setUserRole(null);
        setTokenInfo(null);
        localStorage.removeItem('AuthToken');
      } finally {
        setLoading(false);
      }
    };

    verificarToken();
  }, []);

  return (
    <Router>
      {loading || verificandoMantenimiento ? (
        <Loader />
      ) : enMantenimiento && userRole !== 'admin' && userRole !== 'tecnico' ? (
        <Mantenimiento />
      ) : (
        <>
          <ScrollToTop />
          <Header authenticated={authenticated} />
          <AppContent
            authenticated={authenticated}
            userRole={userRole}
            tokenInfo={tokenInfo}
          />
          <Footer />
        </>
      )}
    </Router>
  );
};

export default Routering;
